import { useEffect } from "react";
import { NextRouter } from "next/router";
import { DbBusiness } from "canbook-data/business/models";

type Props = {
  router: NextRouter;
  loadingBusinesses: boolean;
  businesses: DbBusiness[];
};

export const useBusinessRedirect = ({
  router,
  loadingBusinesses,
  businesses,
}: Props) => {
  useEffect(() => {
    if (!loadingBusinesses) {
      if (businesses.length === 0) {
        router.replace("/onboard");
      } else {
        router.replace("/");
      }
    }
  }, [loadingBusinesses, businesses, router]);
};
